import round from 'lodash/round';

import { TOOLTIP_SCOP } from '~src/constants';
import { DropdownOption, HeatPumpOutdoorUnit, SolarPanel } from '~src/model';
import { formatSolarPanelUnitType } from '~src/util';

import { getTooltipForNoiseLevel } from '../Information/heatPump/util';

export const formatHeatPumpInfoRows = ({
  effect7,
  energyLabel,
  scop,
  noiseLevel,
}: Pick<HeatPumpOutdoorUnit, 'effect7' | 'energyLabel' | 'scop' | 'noiseLevel'>): DropdownOption[] => [
  { label: 'Ydelse', value: `${effect7.radiator}` },
  { label: 'Energiklasse', value: `${energyLabel?.radiator}` },
  { label: 'SCOP', tooltip: TOOLTIP_SCOP, value: `${scop.radiator}` },
  { label: 'Støjniveau', tooltip: getTooltipForNoiseLevel(noiseLevel), value: `${noiseLevel} dB` },
];

export const formatSolarPanelInfoRows = ({
  size,
  type,
  weight,
  capacity,
}: Pick<SolarPanel, 'size' | 'type' | 'weight' | 'capacity'>): DropdownOption[] => [
  { label: 'Areal', value: `${round(((size?.depth ?? 0) * (size?.width ?? 0)) / 10_000, 2)} m2` },
  { label: 'Type', value: formatSolarPanelUnitType(type) },
  { label: 'Vægt', value: `${weight} kg` },
  { label: 'Paneleffekt', value: `${round(capacity, 2)} kWp` },
];
